import html from "../assets/logos/html5.png";
import css from "../assets/logos/css.png";
import js from "../assets/logos/js.png"; 
import node from "../assets/logos/node.png"; 
import react from "../assets/logos/react.png"; 
import express from "../assets/logos/express.png"; 
import mongoDB from "../assets/logos/mongoDB.png"; 
import psql from "../assets/logos/psql.png"; 
import tailwindcss from "../assets/logos/tailwindcss.png";  
import styledcomponents from "../assets/logos/styledcomponents.png";  
import python from "../assets/logos/python.png";  
import flask from "../assets/logos/flask.png";  
import jasmine from "../assets/logos/jasmine.png";  
import jest from "../assets/logos/jest.png";  
import testingLibrary from "../assets/logos/testing-library.svg";  
import typescript from "../assets/logos/typescript.png";  

export const logos = [
    {
        id: 1, 
        text: "html", 
        img: html, 
        alt: "html logo", 
    }, 
    {
        id: 2, 
        text: "css", 
        img: css, 
        alt: "css logo", 
    }, 
    {
        id: 3, 
        text: "js", 
        img: js, 
        alt: "javascript logo", 
    }, 
    {
        id: 4, 
        text: "node", 
        img: node, 
        alt: "node logo", 
    }, 
    {
        id: 5, 
        text: "react", 
        img: react, 
        alt: "react logo", 
    }, 
    {
        id: 6, 
        text: "typescript", 
        img: typescript, 
        alt: "typescript logo", 
    }, 
    {
        id: 7, 
        text: "python", 
        img: python, 
        alt: "python logo", 
    }, 
    {
        id: 8, 
        text: "tailwindcss", 
        img: tailwindcss, 
        alt: "tailwindcss logo", 
    }, 
    {
        id: 9, 
        text: "styledcomponents", 
        img: styledcomponents, 
        alt: "styledcomponents logo", 
    }, 
    {
        id: 10, 
        text: "express", 
        img: express, 
        alt: "express logo", 
    }, 
    {
        id: 11, 
        text: "flask", 
        img: flask, 
        alt: "flask logo", 
    }, 
    {
        id: 12, 
        text: "jasmine", 
        img: jasmine, 
        alt: "jasmine logo", 
    }, 
    {
        id: 13, 
        text: "jest", 
        img: jest, 
        alt: "jest logo", 
    }, 
    {
        id: 14, 
        text: "testingLibrary", 
        img: testingLibrary, 
        alt: "testingLibrary logo", 
    }, 
    {
        id: 15, 
        text: "psql", 
        img: psql, 
        alt: "psql logo", 
    }, 
    {
        id: 16, 
        text: "mongoDB", 
        img: mongoDB, 
        alt: "mongoDB logo", 
    }, 
]; 